export const TUTORIAL_URL = "https://video.loola.tv/loola_enable_camera_chrome.mp4";
